import { useAppConfig } from '@/appConfig/useAppConfig.ts';
import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { httpClient } from '@/httpClient/axios.ts';

interface OtpCheckResponse {
  data: {
    success: boolean;
    verified: boolean;
  };
}

interface OtpSendResponse {
  data: { success: boolean; sent: boolean };
}

interface UseOtpApi {
  checkOtp: (channel: string, recipient: string, otp: string) => Promise<OtpCheckResponse>;
  sendOtp: (channel: string, recipient: string, locale: string) => Promise<OtpSendResponse>;
}

export const useOtp = (): UseOtpApi => {
  const meta = useAppConfig();
  const { eventConfig } = useEventConfig();

  const checkOtp = (channel: string, recipient: string, otp: string): Promise<OtpCheckResponse> => {
    if (!meta || !eventConfig) {
      return Promise.reject();
    }
    return httpClient.post(
      meta.api.contactVerificationCheck,
      {
        channel: channel,
        recipient: recipient,
        otp: otp,
      },
      { timeout: 10000 }
    );
  };

  const sendOtp = (
    channel: string,
    recipient: string,
    locale: string = eventConfig!.meta.defaultLocale
  ): Promise<OtpSendResponse> => {
    if (!meta || !eventConfig) {
      return Promise.reject();
    }
    return httpClient.post(
      meta.api.contactVerificationSend,
      {
        channel: channel,
        recipient: recipient,
        locale: locale,
        country: eventConfig.meta.country.toLowerCase(),
      },
      { timeout: 10000 }
    );
  };

  return { checkOtp, sendOtp };
};
